import { useContext } from "react";
import context, { IContactProviderContext } from "../state/context";

export default (): IContactProviderContext => useContext(context);
